import api from "store/api/api";

export const LOGIN = (credentials) => api.post("/auth/customer", credentials);
export const REGISTER = (credentials) =>
  api.post("/auth/local/register", credentials);
export const GETUSERDETAILS = () => api.get("/user");
export const UPDATE_USER = (data) => api.put(`/user`, data);
export const VERIFY_PHONE_NUMBER = (data) => api.get(`/auth/customer/checkMobileAvailability/${data}`);
